import { useMutation } from '@apollo/client';
import { toggleArticleInspire } from '../mutations/toggleArticleInsipre';

export const useToggleArticleInspireMutation = ({ articleId }: { articleId: string }) =>
  useMutation(toggleArticleInspire, {
    variables: { articleId },
  });
